/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiErrorResponse {
  Error: Error
}

export interface AssistantBaseResponse {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /** Assistant name */
  Name: string
  /** Assistant description */
  Description?: string | null
  /** Assistant instructions */
  Instructions?: string | null
  /**
   *
   *
   * 0 = Light
   *
   * 1 = Advanced
   */
  GptModel: GptModel
  /**
   *
   *
   * 1 = QnaKnowledgeBase
   *
   * 2 = AssistantsApi
   */
  DataSource: KnowledgeBaseType
  /**
   * Assistant tenant id
   * @format int32
   */
  TenantId: number
  /** Is default assistant */
  IsDefault: boolean
}

export interface AssistantCreateRequest {
  /**
   * Assistant name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  /**
   * Assistant description
   * @maxLength 512
   */
  Description?: string | null
  /**
   * Assistant instructions
   * @maxLength 512
   */
  Instructions?: string | null
  /**
   *
   *
   * 0 = Light
   *
   * 1 = Advanced
   */
  GptModel: GptModel
  /**
   *
   *
   * 1 = QnaKnowledgeBase
   *
   * 2 = AssistantsApi
   */
  DataSource: KnowledgeBaseType
}

export interface AssistantResponse {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /** Assistant name */
  Name: string
  /** Assistant description */
  Description?: string | null
  /** Assistant instructions */
  Instructions?: string | null
  /**
   *
   *
   * 0 = Light
   *
   * 1 = Advanced
   */
  GptModel: GptModel
  /**
   *
   *
   * 1 = QnaKnowledgeBase
   *
   * 2 = AssistantsApi
   */
  DataSource: KnowledgeBaseType
  /**
   * Assistant tenant id
   * @format int32
   */
  TenantId: number
  /** Is default assistant */
  IsDefault: boolean
  ExternalKnowledgeBase?: ExternalKnowledgeBaseResponse
}

export interface AssistantUpdateRequest {
  /**
   * Assistant new name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  /**
   * Assistant new description
   * @maxLength 512
   */
  Description?: string | null
  /**
   * Assistant new instructions
   * @maxLength 512
   */
  Instructions?: string | null
  /**
   *
   *
   * 0 = Light
   *
   * 1 = Advanced
   */
  GptModel: GptModel
}

export interface AssistantsPagedViewModel {
  /**
   * Items count
   * @format int32
   */
  TotalCount: number
  /** Items */
  Items: AssistantBaseResponse[]
}

export interface ChatBotBaseResponse {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /** Chat bot access key */
  Key: string
  /** Chat bot name */
  Name: string
  /**
   * Unique id of assistant within the system
   * @format int32
   */
  AssistantId: number
  /** Is chat bot selected as default chat assistant in users tenant */
  IsDefault: boolean
}

export interface ChatBotCreateRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  /**
   * Description
   * @maxLength 4096
   */
  Description?: string | null
  /**
   * Give the model instructions about how it should behave and any context it should reference when generating a response. You can describe the assistant’s personality, tell it what it should and shouldn’t answer, and tell it how to format responses. There’s no token limit for this section, but it will be included with every API call, so it counts against the overall token limit.
   * @minLength 1
   * @maxLength 1024
   */
  SystemMessage: string
  /**
   * Unique id of the assistant within the system
   * @format int32
   */
  AssistantId: number
}

/** Chat bot integration instruction response */
export interface ChatBotIntegrationInstructionResponse {
  Type: string
  Name: string
  Description: string
  Embedding: string
}

export interface ChatBotResponse {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /** Chat bot access key */
  Key: string
  /** Chat bot name */
  Name: string
  /**
   * Unique id of assistant within the system
   * @format int32
   */
  AssistantId: number
  /** Is chat bot selected as default chat assistant in users tenant */
  IsDefault: boolean
  /** Description */
  Description?: string | null
  /** Give the model instructions about how it should behave and any context it should reference when generating a response. You can describe the assistant’s personality, tell it what it should and shouldn’t answer, and tell it how to format responses. There’s no token limit for this section, but it will be included with every API call, so it counts against the overall token limit. */
  SystemMessage: string
}

export interface ChatBotSetAsDefaultRequest {
  /**
   * Unique id of the chat bot within the system
   * @format int32
   */
  ChatBotId: number
}

export interface ChatBotUpdateRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  /**
   * Description
   * @maxLength 4096
   */
  Description?: string | null
  /**
   * Give the model instructions about how it should behave and any context it should reference when generating a response. You can describe the assistant’s personality, tell it what it should and shouldn’t answer, and tell it how to format responses. There’s no token limit for this section, but it will be included with every API call, so it counts against the overall token limit.
   * @minLength 1
   * @maxLength 1024
   */
  SystemMessage: string
}

export interface ChatCompletionCreateRequest {
  /**
   * Chat bot integration key
   * @minLength 1
   */
  Key: string
  /**
   * Chat messages history
   * @maxItems 10
   * @minItems 1
   */
  History: ChatMessage[]
}

export interface ChatMessage {
  /**
   *
   *
   * 0 = User
   *
   * 1 = Assistant
   *
   * 2 = System
   */
  Role: ChatUserRole
  Text?: string | null
  References?: SourceReference[] | null
  FollowUpPrompts?: FollowUpPrompt[] | null
  Prompt?: string | null
  /** @format int32 */
  FollowUpPromptId?: number | null
}

export interface ChatThreadCreateRequest {
  /**
   * Chat bot intergration key
   * @minLength 1
   */
  Key: string
}

export interface ChatThreadResponse {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /** Chat thread uuid */
  Uuid: string
}

/**
 *
 *
 * 0 = User
 *
 * 1 = Assistant
 *
 * 2 = System
 * @format int32
 */
export enum ChatUserRole {
  User = 0,
  Assistant = 1,
  System = 2,
}

export interface DocumentAttachRequest {
  /**
   * Unique id of the assistant within the system
   * @format int32
   */
  AssistantId: number
  /**
   * Document name
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Document url
   * @minLength 1
   */
  Url: string
}

export interface DocumentResponse {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /** Document name */
  Name: string
  /** Document url */
  Url: string
  /**
   *
   *
   * 0 = Idle
   *
   * 1 = InProgress
   *
   * 2 = Completed
   *
   * 3 = Failed
   */
  ProcessingStatus: ProcessingStatus
  /** Is document editable */
  Editable: boolean
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

export interface ExternalKnowledgeBaseResponse {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /**
   *
   *
   * 1 = AzureQna
   *
   * 2 = OpenAIVectorStore
   */
  Type: ExternalKnowledgeBaseType
  QnaSettings?: QnaKnowledgeBaseSettingsResponse
}

/**
 *
 *
 * 1 = AzureQna
 *
 * 2 = OpenAIVectorStore
 * @format int32
 */
export enum ExternalKnowledgeBaseType {
  AzureQna = 1,
  OpenAIVectorStore = 2,
}

export interface FollowUpPrompt {
  /** @format int32 */
  Id: number
  /** @format int32 */
  Order: number
  Prompt?: string | null
}

/**
 *
 *
 * 0 = Light
 *
 * 1 = Advanced
 * @format int32
 */
export enum GptModel {
  Light = 0,
  Advanced = 1,
}

/**
 *
 *
 * 1 = QnaKnowledgeBase
 *
 * 2 = AssistantsApi
 * @format int32
 */
export enum KnowledgeBaseType {
  QnaKnowledgeBase = 1,
  AssistantsApi = 2,
}

/**
 *
 *
 * 0 = Idle
 *
 * 1 = InProgress
 *
 * 2 = Completed
 *
 * 3 = Failed
 * @format int32
 */
export enum ProcessingStatus {
  Idle = 0,
  InProgress = 1,
  Completed = 2,
  Failed = 3,
}

export interface QnaKnowledgeBaseSettingsResponse {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /**
   * Max number of answers to return for a question
   * @format int32
   */
  MaxAnswersCount: number
  /**
   * Answer confidence threshold
   * @format double
   */
  AnswerConfidenceThreshold: number
  /**
   * Max number of follow up prompts to return for a question
   * @format int32
   */
  MaxFollowUpPromptsCount: number
}

export interface QnaKnowledgeBaseSettingsUpdateRequest {
  /**
   * Id
   * @format int32
   */
  Id: number
  /**
   * Created on
   * @format date-time
   */
  CreatedOn: string
  /**
   * Max answers count to fetch
   * @format int32
   * @min 1
   * @max 50
   * @default 5
   */
  MaxAnswersCount: number
  /**
   * Answer confidence threshold
   * @format double
   * @default 0.1
   */
  AnswerConfidenceThreshold: number
  /**
   * Max follow up prompts count
   * @format int32
   * @min 0
   * @max 10
   * @default 5
   */
  MaxFollowUpPromptsCount: number
}

export interface QuestionAnswerPairFollowUpPromptResponse {
  /**
   * Question answer pair id
   * @format int32
   */
  QnaId: number
  /**
   * Follow up prompt order
   * @format int32
   */
  Order: number
  /** Follow up prompt text */
  Text: string
}

export interface QuestionAnswerPairFollowUpPromptUpdateRequest {
  /**
   * Question answer pair id
   * @format int32
   */
  QnaId: number
  /**
   * Follow up prompt order
   * @format int32
   */
  Order: number
  /** Follow up prompt text */
  Text: string
}

export interface QuestionAnswerPairResponse {
  /**
   * Question answer pair id
   * @format int32
   */
  Id: number
  /** Question answer pair questions */
  Questions: string[]
  /** Question answer pair answer */
  Answer: string
  /** Question answer pair parent qna ids */
  ParentQnaIds: number[]
  /** Question answer pair source */
  Source: string
  /** Question answer pair follow up prompts */
  FollowUpPrompts: QuestionAnswerPairFollowUpPromptResponse[]
}

/**
 *
 *
 * 0 = None
 *
 * 1 = Add
 *
 * 2 = Delete
 *
 * 3 = Update
 * @format int32
 */
export enum QuestionAnswerPairUpdateOperation {
  None = 0,
  Add = 1,
  Delete = 2,
  Update = 3,
}

export interface QuestionAnswerPairUpdateRequest {
  /**
   * Question answer pair id
   * @format int32
   */
  Id: number
  /**
   * Question answer pair questions
   * @maxItems 10
   * @minItems 1
   */
  Questions: string[]
  /**
   * Question answer pair answer
   * @minLength 1
   * @maxLength 10000
   */
  Answer: string
  /**
   * Question answer pair parent qna ids
   * @maxItems 10000
   * @minItems 0
   */
  ParentQnaIds: number[]
  /** Question answer pair source */
  Source: string
  /**
   * Question answer pair follow up prompts
   * @minItems 0
   */
  FollowUpPrompts: QuestionAnswerPairFollowUpPromptUpdateRequest[]
  /**
   *
   *
   * 0 = None
   *
   * 1 = Add
   *
   * 2 = Delete
   *
   * 3 = Update
   */
  Operation: QuestionAnswerPairUpdateOperation
}

export interface SourceReference {
  Key: string
  /** @format int32 */
  Index: number
  Name: string
  Url: string
  Text: string
  /** @format double */
  Score: number
}

export type UpdateQnaPairsAsyncPayload = QuestionAnswerPairUpdateRequest[]

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Tabeeb.ChatBotMicroservice
 * @version v1
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  assistants = {
    /**
     * No description
     *
     * @tags Assistants
     * @name GetAllAsync
     * @summary Request is used to get assistants
     * @request GET:/chat-bot-service/api/assistants
     * @secure
     */
    getAllAsync: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @min 0
         * @max 100
         * @default 50
         */
        take?: number
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AssistantsPagedViewModel, any>({
        path: `/chat-bot-service/api/assistants`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name CreateAsync
     * @summary Request is used to create assistant
     * @request POST:/chat-bot-service/api/assistants
     * @secure
     */
    createAsync: (data: AssistantCreateRequest, params: RequestParams = {}) =>
      this.http.request<AssistantBaseResponse, void>({
        path: `/chat-bot-service/api/assistants`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name GetAsync
     * @summary Request is used to get assistant by id
     * @request GET:/chat-bot-service/api/assistants/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<AssistantResponse, ApiErrorResponse>({
        path: `/chat-bot-service/api/assistants/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name UpdateAsync
     * @summary Request is used to update assistant
     * @request PUT:/chat-bot-service/api/assistants/{id}
     * @secure
     */
    updateAsync: (id: number, data: AssistantUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/chat-bot-service/api/assistants/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name DeleteAsync
     * @summary Request is used to delete assistant
     * @request DELETE:/chat-bot-service/api/assistants/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/chat-bot-service/api/assistants/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name UpdateQnaSettingsAsync
     * @summary Request is used to update assistant qna settings
     * @request PUT:/chat-bot-service/api/assistants/qnaSettings
     * @secure
     */
    updateQnaSettingsAsync: (data: QnaKnowledgeBaseSettingsUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/chat-bot-service/api/assistants/qnaSettings`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  chat = {
    /**
     * No description
     *
     * @tags Chat
     * @name CreateThreadAsync
     * @summary Request is used to create chat thread
     * @request POST:/chat-bot-service/api/chat/threads
     */
    createThreadAsync: (data: ChatThreadCreateRequest, params: RequestParams = {}) =>
      this.http.request<ChatThreadResponse, void>({
        path: `/chat-bot-service/api/chat/threads`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name PostThreadMessageAsync
     * @summary Request is used to post a chat message to the thread
     * @request POST:/chat-bot-service/api/chat/threads/{threadUuid}/messages
     */
    postThreadMessageAsync: (threadUuid: string, data: ChatCompletionCreateRequest, params: RequestParams = {}) =>
      this.http.request<ChatMessage[], ApiErrorResponse | void>({
        path: `/chat-bot-service/api/chat/threads/${threadUuid}/messages`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  chatBots = {
    /**
     * No description
     *
     * @tags ChatBots
     * @name GetAllAsync
     * @summary Request is used to get chat bots
     * @request GET:/chat-bot-service/api/chat-bots
     * @secure
     */
    getAllAsync: (
      query: {
        /** @format int32 */
        assistantId: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ChatBotBaseResponse[], any>({
        path: `/chat-bot-service/api/chat-bots`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatBots
     * @name CreateAsync
     * @summary Request is used to create chat bot
     * @request POST:/chat-bot-service/api/chat-bots
     * @secure
     */
    createAsync: (data: ChatBotCreateRequest, params: RequestParams = {}) =>
      this.http.request<ChatBotBaseResponse, ApiErrorResponse | void>({
        path: `/chat-bot-service/api/chat-bots`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatBots
     * @name GetAsync
     * @summary Request is used to get chat bot by id
     * @request GET:/chat-bot-service/api/chat-bots/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<ChatBotResponse, ApiErrorResponse>({
        path: `/chat-bot-service/api/chat-bots/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatBots
     * @name UpdateAsync
     * @summary Request is used to update chat bot
     * @request PUT:/chat-bot-service/api/chat-bots/{id}
     * @secure
     */
    updateAsync: (id: number, data: ChatBotUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/chat-bot-service/api/chat-bots/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatBots
     * @name DeleteAsync
     * @summary Request is used to delete chat bot
     * @request DELETE:/chat-bot-service/api/chat-bots/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/chat-bot-service/api/chat-bots/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatBots
     * @name GetIntegrationInstructionsAsync
     * @summary Request is used to get chat bot integration instructions
     * @request GET:/chat-bot-service/api/chat-bots/{id}/integration-instructions
     * @secure
     */
    getIntegrationInstructionsAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<ChatBotIntegrationInstructionResponse[], ApiErrorResponse>({
        path: `/chat-bot-service/api/chat-bots/${id}/integration-instructions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatBots
     * @name GetDefaultChatBotForTenantAsync
     * @summary Request is used to get default chat bot for users tenant
     * @request GET:/chat-bot-service/api/chat-bots/default
     * @secure
     */
    getDefaultChatBotForTenantAsync: (params: RequestParams = {}) =>
      this.http.request<ChatBotBaseResponse, ApiErrorResponse>({
        path: `/chat-bot-service/api/chat-bots/default`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatBots
     * @name SetChatBotAsDefaultForTenantAsync
     * @summary Request is used to set default chat bot for users tenant
     * @request PUT:/chat-bot-service/api/chat-bots/default
     * @secure
     */
    setChatBotAsDefaultForTenantAsync: (data: ChatBotSetAsDefaultRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/chat-bot-service/api/chat-bots/default`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  documents = {
    /**
     * No description
     *
     * @tags Documents
     * @name GetAllAsync
     * @summary Request is used to get documents by assistant id
     * @request GET:/chat-bot-service/api/documents
     * @secure
     */
    getAllAsync: (
      query: {
        /** @format int32 */
        assistantId: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<DocumentResponse[], any>({
        path: `/chat-bot-service/api/documents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name AttachDocumentAsync
     * @summary Request is used to attach document to assistant
     * @request POST:/chat-bot-service/api/documents
     * @secure
     */
    attachDocumentAsync: (data: DocumentAttachRequest, params: RequestParams = {}) =>
      this.http.request<DocumentResponse, ApiErrorResponse | void>({
        path: `/chat-bot-service/api/documents`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name GetAsync
     * @summary Request is used to get document by id
     * @request GET:/chat-bot-service/api/documents/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<DocumentResponse, ApiErrorResponse>({
        path: `/chat-bot-service/api/documents/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DeleteDocumentAsync
     * @summary Request is used to delete document from assistant
     * @request DELETE:/chat-bot-service/api/documents/{id}
     * @secure
     */
    deleteDocumentAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/chat-bot-service/api/documents/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name GetQnaPairsAsync
     * @summary Request is used to get question answers pairs by document id
     * @request GET:/chat-bot-service/api/documents/{id}/qnaPairs
     * @secure
     */
    getQnaPairsAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<QuestionAnswerPairResponse[], ApiErrorResponse>({
        path: `/chat-bot-service/api/documents/${id}/qnaPairs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name UpdateQnaPairsAsync
     * @summary Request is used to update question answers pairs for document
     * @request PUT:/chat-bot-service/api/documents/{id}/qnaPairs
     * @secure
     */
    updateQnaPairsAsync: (id: number, data: UpdateQnaPairsAsyncPayload, params: RequestParams = {}) =>
      this.http.request<QuestionAnswerPairResponse[], ApiErrorResponse | void>({
        path: `/chat-bot-service/api/documents/${id}/qnaPairs`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
